import angular from 'angular';
import extractsService from './extracts.service';

let extractsModule = angular.module('extracts', []).service('extractsService', extractsService);

export default extractsModule;



// WEBPACK FOOTER //
// ./app/common/extracts/extracts.js